import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Pagetitle } from '@ktag/styleguide/dist/react';
import BackToOverview from 'components/backToOverview/BackToOverview';
import SubscribeConfirmationProgress from './SubscribeConfirmationProgress';

interface Props {
  isSuccessful: boolean;
  isTimeout?: boolean;
}

const SubscribeConfirmation = ({ isSuccessful, isTimeout }: Props) => {
  const { t } = useTranslation('newsletter');

  return (
    <div className="subscribeconfirmation richtext">
      <Pagetitle additionalClassNames="subscribe__header">
        {t('subscribe_header')}
      </Pagetitle>
      <SubscribeConfirmationProgress isSuccess={isSuccessful} />
      {isSuccessful ? (
        <Box
          heading={t('subscribe_infobox_subscription_successful_title')}
          type="positive"
        >
          <p>{t('subscribe_infobox_subscription_successful_text')}</p>
        </Box>
      ) : (
        <Box heading={t('subscribe_infobox_subscription_failed_title')} type="negative">
          <p>
            {isTimeout
              ? t('subscribe_infobox_subscription_timeout_text')
              : t('subscribe_infobox_subscription_failed_text')}
          </p>
        </Box>
      )}
      <BackToOverview />
    </div>
  );
};

export default SubscribeConfirmation;
